<template>
    <div>
        <InputDetail v-if="!onlyIcon"
                class="datePickerInput"
                label="Laufzeit"
                placeholder="TT.MM.JJ (bis TT.MM.JJ)"
                icon="icon-calendar"
                :iconBorder="true"
                icon-size="1.8em"
                @focus="openCalendar"
                @click="openCalendar"
        ></InputDetail>
      <span v-if="onlyIcon" class="icon icon-calendar" @click="openCalendar"></span>
        <Dialog :has-backdrop="true" :show="showPicker" @close="closeCalendar">
            <div>
                <h4>Laufzeit hinzufügen und bestätigen</h4>
                <v-date-picker style="border: none"
                               mode="range"
                               color="gray"
                               is-inline
                               :columns="2"
                               v-model="range"
                />
                <AdaButton @click="saveClicked" title="AUSWAHL BESTÄTIGEN" type="createButton"></AdaButton>
                <p class="infoText" v-html="infoText"></p>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "../../components/dialog/Dialog";
    import InputDetail from "../inputs/InputDetail";
    import AdaButton from "../buttons/AdaButton";

    export default {
        components: {
            AdaButton,
            Dialog,
            InputDetail
        },
        props:{
           infoText:{
               type:String,
               default:''
           },
          onlyIcon:{
               type:Boolean,
               default:false
           }
        },
        data() {
            return {
                showPicker: false,
                inputRanges: [],
                range: {
                    start: {},
                    end: {}
                }
            }
        },
        methods: {
            closeCalendar: function () {
                this.showPicker = false;
                this.range = {
                    start: {},
                    end: {}
                };
            },
            openCalendar: function () {
                this.showPicker = true;
            },
            saveClicked: function () {
                if (this.range.start instanceof Date && this.range.end instanceof Date) {
                    let range = this.formatDate(this.range.start) + ' - ' + this.formatDate(this.range.end);
                    this.inputRanges.push(range);
                }
                this.$emit('close', this.range);
                this.closeCalendar();
            },
            formatDate: function (date) {
                let day = date.getDate() + '';
                let month = (date.getMonth() + 1) + '';
                let year = date.getFullYear() + '';
                year = year.substring(2, 4);
                if (day.length === 1) {
                    day = '0' + day;
                }
                if (month.length === 1) {
                    month = '0' + month;
                }
                return day + '.' + month + '.' + year;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .datePickerInput.inputContainer {
        margin-bottom: 0px;
    }

    .infoText{
        max-width: fit-content;
        font-size: 0.9em;
    }

</style>